import { FAILURE, LOADING, NAMESPACE, NOT_ASKED, ADDRESS_REQUEST } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { addressRequest, loading, failure, success, notAsked } from './actions';
import { selectStatus, selectTransferId, selectResults, selectError } from './selectors';

export {
  addressRequest,
  ADDRESS_REQUEST,
  loading,
  failure,
  notAsked,
  success,
  reducer,
  sagas,
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  selectStatus,
  selectTransferId,
  selectResults,
  selectError,
};



// WEBPACK FOOTER //
// ./src/services/addressPreview/index.js